import { Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppService } from '../../app.service';
import { messageService } from '../../message.service';
import { PaginationService } from 'src/app/PaginationService';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { SuccessSnackbarComponent } from '../success-snackbar/success-snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EditorComponent } from '../../editor/editor.component';
import { DomSanitizer } from '@angular/platform-browser';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import { utcToZonedTime } from 'date-fns-tz';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-static-audit-trail',
  templateUrl: './static-audit-trail.component.html',
  styleUrls: ['./static-audit-trail.component.scss']
})

export class StaticAuditTrailComponent implements OnInit {

  popupDataTitle: PopupData = { title: '' };

  isProcessing = false;
  noData: boolean = false;
  pager: any = {};
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  searchValue: any;
  whereClause: any;
  columnListAuditTrails: any;
  columnListAuditTrails1: any;
  fiveColumnForAuditTrails: any;
  spColumnForAuditTrails: any;
  fiveFieldLabelsColumnForAuditTrails: any;
  spFieldLabelsColumnForAuditTrails: any;
  tableOrViewNameForAuditTrails: any;
  columnListsAuditTrails: any = {};
  dataTypeList: any = [];
  listForAuditTrails: any = [];
  makeStickyColumns: any;
  pagedItems: any[];
  selectedColumns: any = [];
  columnList: any;
  dropDownForPdfColumn: any;
  isForExcel: boolean = false;
  statusCodeValue: any;
  htmlContent: any;
  extension1: any;
  reportObj: any = {};
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  reportFooterFieldValidation: any;
  pdfDetailSearchText: string = '';
  columnSearchText: string = '';

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  constructor(private appService: AppService, private datePipe: DatePipe, public service: messageService, public dialog: MatDialog, public paginationService: PaginationService, public message: messageService, private elem: ElementRef, private snackBar: MatSnackBar, public sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.wvDocumentLoadedHandler = this.wvDocumentLoadedHandler.bind(this);
  }

  wvDocumentLoadedHandler(): void {
    const { documentViewer, annotationManager, Annotations } = this.wvInstance.Core;
  }

  triggerTrail(data: any) {
    [this.listForAuditTrails, this.columnListsAuditTrails.fieldColumnarray, this.columnListsAuditTrails.columnsListarray1] = [[], [], []];
    this.getCall();
    this.popupDataTitle.title = this.message.report_And_Popup_Name;
    this.visibleAuditTrailPopup = this.dialog.open(this.auditTrailPopup, this.auditTrailPopupConfig);
  }

  @ViewChild('auditTrailPopup', { static: true }) auditTrailPopup: TemplateRef<any>;
  visibleAuditTrailPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('pdfViewerPopup', { static: true }) pdfViewerPopup: TemplateRef<any>;
  visiblePdfViewerPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('imageViewerPopup', { static: true }) imageViewerPopup: TemplateRef<any>;
  visibleImageViewerPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('previewPopup', { static: true }) previewPopup: TemplateRef<any>;
  visiblePreviewPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  @ViewChild('viewer', { static: false }) viewer: ElementRef;

  auditTrailPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px', left: '5.8%' },
    maxWidth: '93vw',
  }

  excelPdfPopupConfig = {
    width: '750px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  }

  pdfViewerPopupConfig = {
    width: '80%',
    height: '80%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  }

  previewPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '100px' },
  }

  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: false,
    singleSelection: false,
    itemsShowLimit: 2,
  };

  getCall() {
    this.isProcessing = true;
    this.tableOrViewNameForAuditTrails = this.message.tableOrView_Name;
    this.columnListAuditTrails1 = this.message.columnList_DB;
    this.spColumnForAuditTrails = "";
    this.spFieldLabelsColumnForAuditTrails = "";
    this.whereClause = this.message.whereClause_AU;
    this.columnList = this.message.columnList_Report;
    this.columnListAuditTrails = this.message.columnList_UI;
    this.makeStickyColumns = "";

    const primary_obj: any = {

      gridName: null,
      tableOrViewName: this.tableOrViewNameForAuditTrails,
      columnsList: this.columnListAuditTrails1 + this.spColumnForAuditTrails,
      fieldLabelsList: this.message.columnList_UI + this.spFieldLabelsColumnForAuditTrails,
      invisibleColumn: this.message.columnList_INVISIBLE ?? "",
      orderByClause: "CREATED_TS DESC",
      fieldSizeList: "",
      columnsListarray: [],
      fieldColumnarray: [],
      invisibleColumnarray: [],
      fieldSizeListArray: [],
      status: this.statusCodeValue,
      codelistGroup: null,
      manualEntryDataFields: this.message.manualEntryDataFields ?? null,
      sectionId: this.message.sectionId,
      templateId: this.message.templateId,
      groupId: null,
      chartStatus: "",
      whereClause: this.whereClause
    }

    this.appService.staticGridAuditTrailsData(primary_obj).subscribe((response1: any) => {
      this.listForAuditTrails = response1;
      this.noData = response1.length;
      primary_obj.columnsListarray = primary_obj.columnsList.split(",");
      primary_obj.fieldColumnarray = primary_obj.fieldLabelsList.split(",");
      primary_obj.fieldSizeListArray = primary_obj.fieldSizeList.split(",");

      this.columnListsAuditTrails.columnsListarray = primary_obj.columnsListarray;
      this.columnListsAuditTrails.fieldLabelsList = primary_obj.fieldLabelsList;
      this.columnListsAuditTrails.fieldColumnarray = [];

      for (let p = 0; p < primary_obj.fieldColumnarray.length; p++) {
        this.columnListsAuditTrails.fieldColumnarray.push({
          "fieldColumnarray": primary_obj.fieldColumnarray[p],
          "width": primary_obj.fieldSizeListArray[p] + 'px'
        })
      }

      this.columnListsAuditTrails.fieldSizeListArray = [];
      for (let w = 0; w < primary_obj.fieldSizeListArray.length; w++) {
        this.columnListsAuditTrails.fieldSizeListArray.push(primary_obj.fieldSizeListArray[w] + 'px');
      }

      let tableData = {
        tablename: primary_obj.tableOrViewName
      };
      this.columnListsAuditTrails.columnsListarray1 = [];
      this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
        //console.log(response2);
        this.dataTypeList = response2;
        for (let m = 0; m < this.columnListsAuditTrails.columnsListarray.length; m++) {
          this.columnListsAuditTrails.columnsListarray1.push({});
          this.columnListsAuditTrails.columnsListarray1[m].columnsListarray = this.columnListsAuditTrails.columnsListarray[m];
          this.columnListsAuditTrails.columnsListarray1[m].dataType = "textbox";
          this.columnListsAuditTrails.columnsListarray1[m].width = this.columnListsAuditTrails.fieldSizeListArray;
          for (let w = 0; w < this.dataTypeList.length; w++) {

            if (this.columnListsAuditTrails.columnsListarray[m] == "\"IN\"") {
              this.columnListsAuditTrails.columnsListarray1[m].dataType = 'CHECKBOX';

            } else {
              if (this.dataTypeList[w].columnName == this.columnListsAuditTrails.columnsListarray[m]) {
                this.columnListsAuditTrails.columnsListarray1[m].dataType = this.dataTypeList[w].fieldType;
              }
            }

          }
        }
        for (let i = 0; i < this.listForAuditTrails.length; i++) {
          for (let y = 0; y < this.dataTypeList.length; y++) {
            if (this.dataTypeList[y].fieldType == 'CHECKBOX') {

              if (this.dataTypeList[y].columnName == 'IN') {
                this.listForAuditTrails[i]["\"IN\""] = this.listForAuditTrails[i]["\"IN\""] == "Y" ? true : false;
              } else {
                this.listForAuditTrails[i][this.dataTypeList[y].columnName] = this.listForAuditTrails[i][this.dataTypeList[y].columnName] == "Y" ? true : (this.listForAuditTrails[i][this.dataTypeList[y].columnName] == "N" ? false : null);
              }
            }
          }
        }

        this.listForAuditTrails = this.listForAuditTrails;
        this.calculateTotalPages = this.collectionSize / this.perPage;
        this.pager.totalPages = undefined;
        this.setPage(1, 0);
        this.isProcessing = false;
      }, (error) => {
        this.isProcessing = false;
      });
      this.message.gridListForAuditTrails = this.listForAuditTrails;
      this.collectionSize = this.listForAuditTrails.length;
      this.isProcessing = false;
    }, (error) => {
      this.isProcessing = false;
      throw error;
    });

    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }

  pagination(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  setPage(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.listForAuditTrails.length, page, this.perPage, targetPage);
    this.pagedItems = this.listForAuditTrails?.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.listForAuditTrails.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.listForAuditTrails.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  counts: any;
  css(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnListsAuditTrails.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = key % 2 == 0 ? 'white' : 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  cancelAuditPopup() {
    this.visibleAuditTrailPopup.close();
  }

  openReportPopup(item: any) {
    this.reportFooterDropdown = [];
    this.ngOnChangesReportFooter();
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') || '{}');
    this.pdfPageSize = 'A4';
    this.dropDownForPdfColumn = this.columnList.split(',')?.filter((item: any) => item != 'Content File').map((column: any) => ({ valueExp: column, displayExp: column })) /* ?.sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp?.trim()?.localeCompare(n.displayExp?.trim())) */ || [];
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report ' : 'PDF Report ';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
  }

  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
  }

  manuallyPicked: boolean;
  pdfPageSizes: any = [];
  pdfPageSize: string = "";
  onCheckboxChange(event: MatSlideToggleChange) {
    if (!event.checked) {
      [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    }
  }

  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  @ViewChild('columns') columns: MatSelect;
  isAllColumns = false;

  toggleAllSelection(value: any) {
    if (value == 'columns') {
      if (this.isAllColumns) this.columns.options.forEach((item: MatOption) => item.select());
      else {
        this.columns.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
      });
    }
  }

  onColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
        this.isAllColumns = this.selectedColumns.length == this.dropDownForPdfColumn.length;
      });
    }
  }

  onSelect() {
    if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(this.selectedColumns);
  }

  onDeSelect() {
    this.onSelect();
  }

  onSelectAll(item: any[]) {
    if (item.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(item);
  }

  onDeSelectAll(item: any[]) {
    if (item.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(item);
  }

  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
  }

  previewData: any;
  previewTemplate(value: any) {
    this.previewData = this.sanitizer.bypassSecurityTrustHtml(value);
    this.visiblePreviewPopup = this.dialog.open(this.previewPopup, this.previewPopupConfig);
  }

  cancelPreviewFunction() {
    this.visiblePreviewPopup.close();
  }

  @ViewChild('angularEditor', { static: true }) angularEditor: TemplateRef<any>;
  visibleAngularEditor: MatDialogRef<TemplateRef<any>>;

  angularEditorConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  caseConversion(format: string, value: any) {

    if (format == 'typical') {
      return value.split('_').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')
    } else {
      return value.split('_').map((word: string, index: number) => index == 0 ? word.toUpperCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')
    }
  }

  editorTitle: string = '';
  editorNgModel: string = '';
  staticClobView(title: string, value: string) {
    this.editorTitle = this.caseConversion('atypical', title);
    this.editorNgModel = value;
    this.visibleAngularEditor = this.dialog.open(this.angularEditor, this.angularEditorConfig);
  }

  disabled: EditorConfig = {
    buttons: [],
  };

  enabled: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  cancelAngularEditor() {
    this.visibleAngularEditor.close();
  }

  generateReport(value: any) {
    if (value == 'Pdf' && this.manuallyPicked && !this.selectedColumns.length) {
      this.showSnackBar('Please select the Columns', 'E');
    } else if (value == 'Pdf' && this.selectedColumns.length > 30) {
      this.showSnackBar('Selected columns exceeded the limit. Limit 30, Selected ' + this.selectedColumns.length, 'E');
    } else {
      const primary_obj = {

        groupId: null
      }

      let $DB = this.columnListAuditTrails1.split(',');

      const columnsToRemoveFrom_DB = ['DOC', 'TEMPLATE', 'DOCUMENT', 'LOGIN_IMAGE', 'LOGO_IMAGE', 'REPORT_IMAGE', 'TRAINING_IMAGE', 'CONTENT_FILE'];

      columnsToRemoveFrom_DB.forEach(column => {
        let index = $DB.indexOf(column);
        if (index !== -1) {
          $DB.splice(index, 1);
        }
      });
      this.columnListAuditTrails1 = $DB.join(',');

      console.log('DB', this.columnListAuditTrails1);

      let $UI = this.message.columnList_UI.split(',');

      const columnsToRemoveFrom_Report = ['Document', 'Template', 'Login Image', 'Logo Image', 'Report Image', 'Training Image', 'Content File'];

      columnsToRemoveFrom_Report.forEach(column => {
        let index = $UI.indexOf(column);
        if (index !== -1) {
          $UI.splice(index, 1);
        }
      });
      this.message.columnList_UI = $UI.join(',');

      console.log('UI', this.message.columnList_UI);

      const secondary_obj: any = {

        tableOrViewName: this.tableOrViewNameForAuditTrails,
        columnsList: this.columnListAuditTrails1,
        fieldLabelsList: this.message.columnList_UI,
        invisibleColumn: "",
        orderByClause: "CREATED_TS DESC",
        fieldSizeList: "",
        sectionId: this.message.sectionId,
        templateId: this.message.templateId,
        columnsListarray: [],
        fieldColumnarray: [],
        invisibleColumnarray: [],
        fieldSizeListArray: [],
        status: this.statusCodeValue,
        codelistGroup: null,
        manualEntryDataFields: this.message.manualEntryDataFields ?? null,
        groupId: null,
        chartStatus: null,
        wherVal: this.message.whereClause_Report,
        reModule: "tms"
      }

      this.reportObj = { ...primary_obj, ...secondary_obj };

      const timestamp = Date.now();
      const formattedDate = new Intl.DateTimeFormat('en-US', {
        day: '2-digit', month: 'short', year: 'numeric',
      }).format(new Date(timestamp)).replace(/[, ]/g, (match) => match === ',' ? '' : '_');

      const extension = value == 'Excel' ? 'xlsx' : 'pdf';

      if (value == 'Excel') {
        const excel_data = {
          ...this.reportObj, title: this.message.report_And_Popup_Name, columns: [],
          "informationTab": { "Report Name": this.message.report_And_Popup_Name, "Exported By": localStorage.getItem("loggedUserName") }
        }

        this.downloadReport('Excel', excel_data, `${this.message.report_And_Popup_Name.replaceAll(" ", "_")}_${formattedDate}.${extension}`);
      } else {
        const pdf_data = {
          ...this.reportObj, "footer": this.selectedReportFooter, title: this.message.report_And_Popup_Name, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.pdfPageSize, logoId: 0, isSaveRep: 'N'
        }

        this.downloadReport('Pdf', pdf_data, `${this.message.report_And_Popup_Name.replaceAll(" ", "_")}_${formattedDate}.${extension}`);
      }
    }
  }

  downloadReport(downloadAs: string, data: any, fileName: string) {
    if (downloadAs == 'Excel') {
      this.isProcessing = true;
      this.appService.downloadExcel(data).subscribe({
        next: (content: any) => {
          let dataType = content.type;
          let binaryData = [];
          binaryData.push(content);
          let downloadLink = document.createElement('a');
          downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
          if (fileName)
            downloadLink.setAttribute('download', fileName);
          document.body.appendChild(downloadLink);
          downloadLink.click();
          this.isProcessing = false;
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      })
    } else {
      this.isProcessing = true;
      this.appService.downloadPdfFile(data).subscribe({
        next: (content: any) => {
          let dataType = content.type;
          let binaryData = [];
          binaryData.push(content);
          let downloadLink = document.createElement('a');
          downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
          if (fileName)
            downloadLink.setAttribute('download', fileName);
          document.body.appendChild(downloadLink);
          downloadLink.click();
          this.isProcessing = false;
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      })
    }
  }

  getClobData(list: any, columnName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: columnName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe((Response: any) => {
      this.htmlContent = Response.result;
      this.editorComponent.openEditor(this.htmlContent, columnName);
    }, (error) => {
      console.log(error);

    })
    this.isProcessing = false;
  }

  downloadDocuments(list: any, columnName: any) {
    this.selectedDocumentName = list.DOWNLOADED_FILE_NAME || 'Document Viewer';
    this.visiblePdfViewerPopup = this.dialog.open(this.pdfViewerPopup, this.pdfViewerPopupConfig);
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: columnName
    }

    this.appService.getDocumentToViewAudit(docObj).subscribe((data: any) => {
      console.log(data.headers);
      const header = data.headers.get('content-type');
      console.log(header);
      this.extension1 = null;
      this.extension1 = 'png';
      if (header == 'image/x-png' || header == "image/x-png, application/json; charset=utf-8") {
        this.extension1 = 'png';
      } else if (header == 'application/pdf') {
        this.extension1 = 'pdf';
      } else if (header == 'text/plain') {
        this.extension1 = 'txt';
      } else if (header == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
        this.extension1 = 'docx';
      } else if (header == 'application/octet-stream') {
        this.extension1 = 'xlsx';
      } else if (header == 'image/jpeg') {
        this.extension1 = 'jpg';
      }

      if (this.extension1 == 'jpg' || this.extension1 == 'jpeg' || this.extension1 == 'png' || this.extension1 == 'JPG' || this.extension1 == 'PNG' || this.extension1 == 'JPEG') {
        this.visibleImageViewerPopup = this.dialog.open(this.imageViewerPopup, this.auditTrailPopupConfig);
        let blob = new Blob([data.body], { type: "image/*" });
        let url = URL.createObjectURL(blob);
        let image: any = document.getElementById("picturewe");
        image.src = url;
      } else {
        this.loadDataInViewer(data, this.extension1);
      }
    })
    this.isProcessing = false;
  }
  selectedDocumentName: String;

  cancelPdfViewer() {
    this.visiblePdfViewerPopup.close();
  }

  cancelImageViewer() {
    this.visiblePdfViewerPopup.close();
    this.visibleImageViewerPopup.close();
  }

  wvInstance: any;
  showUploadDiv: boolean = false;
  isShowToUploadDiffFile: boolean = false;
  loadDataInViewer(data: any, extn: any) {
    this.showUploadDiv = true;


    if (this.wvInstance != undefined && this.wvInstance.UI && false) {
      if (extn == null) {
        this.wvInstance.UI.loadDocument(data);
      } else {
        this.wvInstance.UI.loadDocument(data.body, { extension: extn });
      }
    } else {
      WebViewer({
        path: '../../../wv-resources/lib',
        licenseKey: 'Clinevo Technologies Private Limited (clinevotech.com):OEM:eTrials::B+:AMS(20231004):FEA5C54D0427360AF360B13AC982737B60610F8BAF461E35E56C05DA5C956EAE0AFAB6F5C7', // sign up to get a key at https://dev.apryse.com
        fullAPI: true,
        //  webViewerServer : true,
        disabledElements: [
          'leftPanelButton',
          'toolbarGroup-Annotate',
          'highlightToolGroupButton',
          'underlineToolGroupButton',
          'strikeoutToolGroupButton',
          'squigglyToolGroupButton',
          'freeTextToolGroupButton',
          'shapeToolGroupButton',
          'stickyToolGroupButton',
          'freeHandToolGroupButton',
          'toolsOverlay',
          'eraserToolButton',
          'redoButton',
          'stickyToolButton',
          'textPopup',
          'toggleNotesButton',
          'selectToolButton',
          'highlightToolButton',
          'freeHandToolButton',
          'freeTextToolButton',
          'toolsHeader',
          'printButton',

        ]
      }, this.viewer.nativeElement).then((instance: any) => {
        this.wvInstance = instance;

        instance.UI.disableElements(['printButton']);
        instance.UI.disableFeatures([instance.UI.Feature.Print]);

        // Also block Ctrl+P inside viewer (built-in PDFTron shortcut)
        instance.UI.addEventListener(instance.UI.Events.KEY_DOWN, (e: KeyboardEvent) => {
          instance.UI.addEventListener(instance.UI.Events.KEY_DOWN, (e: KeyboardEvent) => {
            if (e.ctrlKey && e.key.toLowerCase() === 'p') {
              e.preventDefault();
              e.stopPropagation();
              alert('Printing is disabled.');
            } else {
              e.preventDefault();
              e.stopPropagation();
            }
            return false;
          });
        });
        const docViewer = instance.docViewer;
        const annotManager = instance.annotManager;
        // call methods from instance, docViewer and annotManager as needed
        let Feature = instance.Feature;
        instance.UI.setTheme('dark');
        instance.print = false;

        instance.UI.disableElements(['toolbarGroup-Shapes']);
        instance.UI.disableElements(['toolbarGroup-Edit']);
        instance.UI.disableElements(['toolbarGroup-Insert']);
        instance.UI.disableElements(['menuButton']);
        instance.UI.disableElements(['undoButton']);
        instance.UI.disableElements(['highlightToolGroupButton']);

        let FitMode = instance.FitMode;
        if (extn == null) {
          // instance.UI.loadDocument(this.document);
        } else {
          instance.UI.loadDocument(data.body, { extension: extn });
        }

        const { documentViewer } = instance.Core;
        documentViewer.addEventListener('documentLoaded', () => {
          console.log("doc loaded");
        });

        const UIEvents = instance.UI.Events;
        instance.UI.addEventListener(UIEvents.LOAD_ERROR, function (err: any) {
          console.log(err);
        });

        // now you can access APIs through this.webviewer.getInstance()
        //instance.UI.openElement('notesPanel');
        // see https://docs.apryse.com/documentation/web/guides/ui/apis
        // for the full list of APIs

        instance.Core.documentViewer.addEventListener('documentLoaded', this.wvDocumentLoadedHandler)
      })
    }
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterFieldValidation != undefined) {
        this.reportFooterFieldValidation.style.color = '#005c8a';
      }
    }
  }
  ngOnChangesReportFooter() {
    this.isProcessing = true;
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe(
      (data: any) => {
        this.reportFooterDropdown1 = data;
        console.log("data", this.reportFooterDropdown1);
        this.selectBoxForFooter();
        if (this.reportFooterDropdown.length > 0) {
          this.selectedReportFooter = this.reportFooterDropdown[0].valueExp;
        }

        this.isProcessing = false;
      },
      (error: any) => {
        this.isProcessing = false;
      }
    );
  }


  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {

      if (vals.moduleList == "Common") {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
      }

    }
  }

  formatConditionalDate(value: string | Date): string {
    if (!value) return '';


    //const date = new Date(value);

    const userTimezoneED = localStorage.getItem('timezone') || 'Asia/Kolkata';
    const apiDateED = value; // e.g., "2025-07-24T00:00:00Z"
    console.log("apiDateED==" + apiDateED)
    const date = utcToZonedTime(apiDateED, userTimezoneED);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    const dateFormat = this.appService.organizationDetails?.htmlDateFormat || 'dd/MM/yyyy';
    const format = (hours === 0 && minutes === 0 && seconds === 0)
      ? dateFormat
      : `${dateFormat}, HH:mm:ss`;

    return this.datePipe.transform(date, format) || '';
  }

  isColor(value: any): boolean {
    return typeof value === 'string' && ((value.startsWith('#') && !value.endsWith('#')) || value.startsWith('rgb(') || value.startsWith('rgba('));
  }
}
